import React, { useState,forwardRef, useCallback, } from 'react';
import debounce from 'lodash/debounce';
import { Box, TextField, InputAdornment, MenuItem, Select, InputLabel, FormControl } from '@mui/material';
import { TextFieldWithPrefixProps } from "../../types/types";
import {SearchFieldType} from "../../utils/globelSearchType"
import SearchIcon from '@mui/icons-material/Search';
import "./TextFieldWithPrefix.scss"
const TextFieldWithPrefix= forwardRef(({ 
    prefixOptions = [], 
    label = '', 
    onChange = () => null, 
    defaultPrefix = '', 
    ShowIcon = true, 
    selectClassName = '', 
    inputClassName = '', 
    selectSx = {}, 
    inputSx = {}, 
    variant = 'outlined', 
    defaultValue = '',
    slectedPrefix = ''
}: TextFieldWithPrefixProps, ref) => {
    const [prefix, setPrefix] = useState(slectedPrefix || defaultPrefix || '');
    
    const handleSearch = (e: any) => {
        debouncedSearch(e.target.value);
    };
    const debouncedSearch = useCallback(
        debounce((val: string) => {
            onChange({ prefix, text: val });
        }, 500),
        [prefix, onChange]
    );
    const formatLabel = (label: string) => {
        return label
            .replace(/_/g, " ") // Replace underscores with spaces
            .replace(/\b\w/g, (char) => char.toUpperCase()); // Capitalize each word
    };
    return (
        <Box sx={{ display: 'flex', gap: 0, alignItems: 'center' }}>
            <TextField
                className={selectClassName || "Dropdown"}
                sx={{ borderRadius: 0,...selectSx }}
                select
                variant={variant}
                value={prefix}
                onChange={(e) => setPrefix(e.target.value)}
                SelectProps={{
                    displayEmpty: true, // ✅ pass to internal Select component
                }}
            >
                <MenuItem value="" disabled>
                    Select
                </MenuItem>
                {prefixOptions.map((op, index) => (
                    <MenuItem key={index} value={op.value}>
                        {formatLabel(op.label)}
                    </MenuItem>
                ))}
            </TextField>
            <TextField
                disabled={!prefix}
                className={inputClassName || 'TextBox'}
                variant={variant}
                defaultValue={defaultValue}
                type={ SearchFieldType[prefix] ? SearchFieldType[prefix] : 'text'}
                placeholder={label  || "Search by ID, product, or others..."}
                size="small"
                onChange={handleSearch}
                sx={{ ...inputSx }}
                InputProps={{
                    startAdornment: ShowIcon ? (
                    <InputAdornment position="start">
                        <SearchIcon />
                    </InputAdornment>
                    ) : undefined
                }}
            />
        </Box>
    );
})

export default TextFieldWithPrefix